import { render, staticRenderFns } from "./knowledgecats.vue?vue&type=template&id=20a05d06&scoped=true&"
import script from "./knowledgecats.vue?vue&type=script&lang=js&"
export * from "./knowledgecats.vue?vue&type=script&lang=js&"
import style0 from "./knowledgecats.vue?vue&type=style&index=0&id=20a05d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a05d06",
  null
  
)

export default component.exports